import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FormInputAutofocusDirective, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import { DividerComponent, LoaderComponent, NotificationModule, PageComponent } from '@ftr/foundation'
import { PasswordComponent } from '@ftr/ui-password'
import { AppLoaderComponent } from '~app/core/app-loader/app-loader.component'
import { SingleSignOnModule } from '~app/features/single-sign-on/single-sign-on.module'
import { LoginFormComponent } from './login-form/login-form.component'
import { LoginComponent } from './login/login.component'
import { LogoutComponent } from './logout/logout.component'

@NgModule({
  imports: [
    RouterModule,
    SingleSignOnModule,
    DividerComponent,
    PageComponent,
    LoaderComponent,
    NotificationModule,
    AppLoaderComponent,
    PasswordComponent,
    UntypedFormComponent,
    FormInputComponent,
    FormInputAutofocusDirective,
  ],
  declarations: [LoginComponent, LoginFormComponent, LogoutComponent],
  exports: [LoginComponent, LogoutComponent],
})
export class LoginModule {}
